import script from "./CouponReceivedNotice.vue?vue&type=script&setup=true&lang=ts"
export * from "./CouponReceivedNotice.vue?vue&type=script&setup=true&lang=ts"

import "./CouponReceivedNotice.vue?vue&type=style&index=0&id=0dddd80e&lang=css"

const __exports__ = script;

export default __exports__